export enum LicenseStatus {
  TRIAL_AVAILABLE = 'TRIAL_AVAILABLE',
  TRIAL = 'TRIAL',
  FULL = 'FULL',
  EXPIRED = 'EXPIRED',
  AUDITOR = 'AUDITOR'
}

export default LicenseStatus;
